import * as React from 'react';

import { cn } from '@/lib/utils';

type CardGridColumns = 2 | 3 | 4;
type CardGridGap = 'compact' | 'default' | 'comfortable';

const COLUMN_CLASSES: Record<CardGridColumns, string> = {
    2: 'grid-cols-1 md:grid-cols-2',
    3: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3',
    4: 'grid-cols-1 sm:grid-cols-2 xl:grid-cols-4',
};

const GAP_CLASSES: Record<CardGridGap, string> = {
    compact: 'gap-3 sm:gap-4',
    default: 'gap-4 md:gap-6',
    comfortable: 'gap-6',
};

interface CardGridProps extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode;
    columns?: CardGridColumns;
    gap?: CardGridGap;
}

const CardGrid = React.forwardRef<HTMLDivElement, CardGridProps>(
    ({ children, columns = 3, gap = 'default', className, ...props }, ref) => (
        <div
            ref={ref}
            className={cn('grid', COLUMN_CLASSES[columns], GAP_CLASSES[gap], className)}
            {...props}
        >
            {children}
        </div>
    ),
);

CardGrid.displayName = 'CardGrid';

export default CardGrid;
